var userEditPropertySelection = $('.user-property-selection');
var userEditOpsSelection = $('.user-ops-selection');
var userEditDivisionSelection = $('.user-division-selection');
var hidePropertySelection = function(){
    $('.user-assigned-properties').hide();
}

var showAreaSelection = function() {
    $('.user-assigned-area').show();
}

var hideAreaSelection = function() {
    $('.user-assigned-area').hide();
}

var showRegionSelection = function() {
    $('.user-assigned-region').show();
}

var hideRegionSelection = function() {
    $('.user-assigned-region').hide();
}

var showSaleManagerSelection = function() {
    $('.user-assigned-sale-manager').show();
}

var hideSaleManagerSelection = function() {
    $('.user-assigned-sale-manager').hide();
}

var showClientSelection = function() {
    $('.user-assigned-client').show();
}

var hideClientSelection = function() {
    $('.user-assigned-client').hide();
}


var showPropertySelection = function(multiple){
    var assignedProperties = $('.user-assigned-properties');
    if(multiple){
        assignedProperties.find('select').attr('multiple', 'multiple');
        $('.user-assigned-title').text('*Assigned Properties:');

        // destroy instance
        userEditPropertySelection.select2('destroy');

        // reinit
        userEditPropertySelection.select2({
            theme: 'bootstrap-5',
            placeholder: 'Please Choose Propertie(s)',
            multiple: true
        });
        
    }else{
        assignedProperties.find('select').removeAttr('multiple');
        $('.user-assigned-title').text('*Assigned Property:');

        // destroy instance
        userEditPropertySelection.select2('destroy');

        // reinit
        userEditPropertySelection.select2({
            theme: 'bootstrap-5',
            placeholder: 'Please Choose Propertie(s)',
            multiple: false
        });
    }
    assignedProperties.show();
}

var handleUserLevelSelection = function(level) {
    var selectedLevel = parseInt(level);

    if(level == 5){
        $('.room-option').show();
        $('.rebook-option').show();
        $('.residentid-option').show();
    }else{
        $('.room-option').hide();
        $('.rebook-option').hide();
        $('.residentid-option').hide();
    }

    switch(selectedLevel){
        default:
            hidePropertySelection();
            hideAreaSelection();
            hideRegionSelection();
            hideSaleManagerSelection();
            hideClientSelection();
        break;

        // admin or super, no area, regional or property assignment
        case 1:
        case 2:
            hidePropertySelection();
            hideAreaSelection();
            hideRegionSelection();
            hideSaleManagerSelection();
            hideClientSelection();
            break;
        

        // property "manager"
        case 3:
            showPropertySelection(true);
            hideAreaSelection();
            hideRegionSelection();
            hideClientSelection();
            hideSaleManagerSelection();
            break;

        // area "manager"
        case 6:
            showAreaSelection();
            hideRegionSelection();
            hidePropertySelection();
            hideClientSelection();
            hideSaleManagerSelection();
            break;

        // regional "manager"
        case 7:
            showRegionSelection();
            hideAreaSelection();
            hidePropertySelection();
            hideClientSelection();
            hideSaleManagerSelection();
            break;

        // resident or team, single property selection
        case 4:
            showPropertySelection(true);
            hideAreaSelection();
            hideRegionSelection();
            hideClientSelection();
            hideSaleManagerSelection();
            break;
            
        case 5:
            showPropertySelection(false);
            hideAreaSelection();
            hideRegionSelection();
            hideClientSelection();
            hideSaleManagerSelection();
            break;

        case 9:
            hideRegionSelection();
            hideAreaSelection();
            hidePropertySelection();
            hideClientSelection();
            showSaleManagerSelection();
            break;

        case 10:
            hideRegionSelection();
            hideAreaSelection();
            hidePropertySelection();
            hideSaleManagerSelection();
            showClientSelection();
            break;
    }
}

$('select[name=user_level]').on('change', function(e){
    handleUserLevelSelection($(this).val());
});


/**
 * Assigning Properties per User
 */
userEditPropertySelection.select2({
    theme: 'bootstrap-5',
    placeholder: 'Please Choose Propertie(s)'
});


/**
 * Assigning Ops per User
 */
userEditOpsSelection.select2({
    theme: 'bootstrap-5',
    placeholder: 'Please Choose Ops / Portfolio Manager(s)'
});

/**
 * Assigning Division per User
 */
userEditDivisionSelection.select2({
    theme: 'bootstrap-5',
    placeholder: 'Please Choose Division(s)'
});

// init — restore field visibility on page load (e.g. after validation error redirect)
handleUserLevelSelection($('select[name=user_level]').val());
